import i18n from "@src/common/lib/i18n";
import utils from "@src/common/utils";
import {
  Dic
} from "$utils";
export const tableOption = function (staffShow, operateShow) {
  if (staffShow) {
    return {
      add: "新增",
      edit: "修改",
      view: "查看",
      page: true,
      selection: true,
      index: false,
      indexLabel: "序号",
      refreshBtn: false,
      columnBtn: false,
      stripe: true,
      addBtn: false,
      editBtn: false,
      delBtn: false,
      viewFormSlot: true,
      labelSuffix: "：",
      labelPosition: "right",
      size: "small",
      maxHeight: "100%",
      labelWidth: "110px",
      menuAlign: "center",
      searchMenuSpan: 6,
      searchBtn: false,
      dialogHeight: 270,
      dialogWidth: "700px",
      emptyText: "暂无数据",
      column: [{
          label: "车牌号",
          prop: "plateCode",
          align: "right",
          search: true,
          span: 24,
          viewSpan: 12,
          addDisplay: true,
          editDisplay: false,
          editDisabled: false,
          viewDisplay: true,
          overHidden: true,
          rules: [{
            required: true,
            message: "请输入车牌号",
            trigger: ["change", "blur"]
          }]
        },
        {
          label: "车主姓名",
          prop: "name",
          align: "center",
          search: true,
          addDisplay: true,
          editDisplay: false,
          editDisabled: false,
          formslot: true,
          overHidden: true,
          span: 12,
          rules: [{
            required: true,
            message: "请选择车主",
            trigger: ["change", "blur"]
          }]
        },
        {
          label: "车主电话",
          prop: "phone",
          hide: false,
          search: false,
          addDisplay: true,
          addDisabled: true,
          editDisplay: false,
          viewDisplay: true,
          searchPlaceholder: "请选择车主",
          span: 12,
          align: "right",
          rules: [{
            required: true,
            message: "请选择车主",
            trigger: "change"
          }]
        },
        {
          label: "车辆颜色",
          prop: "vehicleColor",
          type: "select",
          hide: false,
          search: true,
          addDisplay: true,
          editDisplay: false,
          viewDisplay: true,
          span: 12,
          align: "right",
          placeholder: "请输入车辆颜色",
          dicData: Dic.find("SENU039"),
          viewFormatter: (row, value) => {
            if (value) {
              return Dic.findByValue("SENU039", value);
            }
            return "";
          },
          formatter: function (row, value) {
            return value ? Dic.findByValue("SENU039", value) : "";
          }
        },
        {
          label: "车牌颜色",
          prop: "plateColor",
          type: "select",
          search: false,
          searchSlot: false,
          addDisplay: true,
          editDisplay: false,
          viewDisplay: true,
          span: 12,
          align: "right",
          placeholder: "请选择车牌颜色",
          dicData: Dic.find("SENU040"),
          viewFormatter: (row, value) => {
            if (value) {
              return Dic.findByValue("SENU040", value);
            }
            return "";
          },
          formatter: function (row, value) {
            return value ? Dic.findByValue("SENU040", value) : "";
          }
        },
        {
          label: "车牌类型",
          prop: "plateType",
          type: "select",
          hide: true,
          search: false,
          addDisplay: true,
          editDisplay: false,
          viewDisplay: false,
          span: 12,
          align: "right",
          placeholder: "请选择车牌类型",
          dicData: Dic.find("SENU041"),
          viewFormatter: (row, value) => {
            if (value) {
              return Dic.findByValue("SENU041", Number(value));
            }
            return "";
          },
          formatter: function (row, value) {
            return value ? Dic.findByValue("SENU041", value) : "";
          }
        },

        {
          label: "车辆类型",
          prop: "vehicleType",
          type: "select",
          search: true,
          hide: false,
          addDisplay: true,
          editDisplay: false,
          viewDisplay: true,
          span: 12,
          align: "right",
          placeholder: "请选择车辆类型",
          dicData: Dic.find("SENU038"),
          viewFormatter: (row, value) => {
            if (value) {
              return Dic.findByValue("SENU038", value);
            }
            return "";
          },
          formatter: function (row, value) {
            return value ? Dic.findByValue("SENU038", value) : "";
          }
        },

        {
          label: "车主类型",
          prop: "personnelType",
          type: "select",
          search: false,
          hide: true,
          addDisplay: false,
          editDisplay: false,
          viewDisplay: true,
          span: 12,
          labelWidth: "100px",
          viewFormatter: (row, value) => {
            if (Number(value) === 1) {
              return "员工";
            } else if (Number(value) === 2) {
              return "访客";
            }
            return "";
          },
          formatter: (row, value) => {
            if (Number(value) === 1) {
              return "员工";
            } else if (Number(value) === 2) {
              return "访客";
            }
            return "";
          },
          dicData: [{
              label: "员工",
              value: 1
            },
            {
              label: "访客",
              value: 2
            }
          ]
        },
        // {
        //     label: '车辆品牌',
        //     prop: 'visitorVehicleTypeName',
        //     search: true,
        //     type: 'select',
        //     span: 24,

        // },
        // {
        //   label: "录入时间",
        //   prop: "modifyTime",
        //   search: false,
        //   span: 24,
        //   type: "datetime",
        //   hide: true,
        //   formatter: function (row, value) {
        //     return value
        //       ? utils.Dates.dayjs(value).format("YYYY-MM-DD HH:mm:ss")
        //       : "";
        //   }
        // },
        {
          label: "车辆备注",
          prop: "desc",
          type: "textarea",
          hide: false,
          search: false,
          addDisplay: true,
          editDisplay: false,
          viewDisplay: true,
          span: 24,
          align: "right"
        }
      ]
    };
  } else {
    return {
      add: "新增",
      edit: "修改",
      view: "查看",
      page: true,
      selection: true,
      index: false,
      indexLabel: "序号",
      refreshBtn: false,
      columnBtn: false,
      stripe: true,
      addBtn: false,
      editBtn: false,
      delBtn: false,
      viewFormSlot: true,
      labelSuffix: "：",
      labelPosition: "right",
      size: "small",
      maxHeight: "100%",
      labelWidth: "140px",
      menuAlign: "center",
      searchMenuSpan: 6,
      searchBtn: false,
      dialogHeight: 400,
      dialogWidth: "700px",
      emptyText: "暂无数据",
      column: [{
          label: "车牌号",
          prop: "plateCode",
          align: "right",
          search: true,
          span: 24,
          viewSpan: 12,
          addDisplay: true,
          editDisplay: false,
          editDisabled: false,
          overHidden: true,
          rules: [{
            required: true,
            message: "请输入车牌号",
            trigger: "blur"
          }]
        },
        {
          label: "车主姓名",
          prop: "name",
          align: "right",
          hide: false,
          search: true,
          addDisplay: true,
          editDisplay: false,
          editDisabled: false,
          overHidden: true,
          formslot: true,
          span: 12,
          rules: [{
            required: true,
            message: "请输入车主姓名",
            trigger: ["change", "blur"]
          }]
        },
        {
          label: "车主电话",
          prop: "phone",
          hide: false,
          search: false,
          addDisplay: false,
          editDisplay: false,
          span: 12,
          align: "right",
          rules: [{
            required: true,
            message: "请输入车主电话",
            trigger: "blur"
          }]
        },
        {
          label: "车辆颜色",
          prop: "vehicleColor",
          type: "select",
          hide: false,
          search: true,
          addDisplay: true,
          editDisplay: false,
          span: 12,
          align: "right",
          placeholder: "请输入车辆颜色",
          // rules: [{
          //   required: true,
          //   message: '请输入车辆颜色',
          //   trigger: 'blur'
          // }],
          dicData: Dic.find("SENU039"),
          viewFormatter: (row, value) => {
            if (value) {
              return Dic.findByValue("SENU039", Number(value));
            }
            return "";
          },
          formatter: function (row, value) {
            return value ? Dic.findByValue("SENU039", value) : "";
          }
        },
        {
          label: "车牌颜色",
          prop: "plateColor",
          type: "select",
          hide: true,
          search: false,
          searchSlot: false,
          addDisplay: true,
          editDisplay: false,
          span: 12,
          align: "right",
          placeholder: "请选择车牌颜色",
          dicData: Dic.find("SENU040"),
          viewFormatter: (row, value) => {
            if (value) {
              return Dic.findByValue("SENU040", Number(value));
            }
            return "";
          },
          formatter: function (row, value) {
            return value ? Dic.findByValue("SENU040", value) : "";
          }
        },
        {
          label: "车牌类型",
          prop: "plateType",
          type: "select",
          hide: true,
          search: false,
          addDisplay: true,
          editDisplay: false,
          span: 12,
          align: "right",
          placeholder: "请选择车牌类型",
          // rules: [{
          //   required: true,
          //   message: '请输入车牌类型',
          //   trigger: 'blur'
          // }],
          dicData: Dic.find("SENU041"),
          viewFormatter: (row, value) => {
            if (value) {
              return Dic.findByValue("SENU041", Number(value));
            }
            return "";
          },
          formatter: function (row, value) {
            return value ? Dic.findByValue("SENU041", value) : "";
          }
        },

        {
          label: "车辆类型",
          prop: "vehicleType",
          type: "select",
          search: true,
          hide: false,
          addDisplay: true,
          editDisplay: false,
          span: 12,
          align: "right",
          placeholder: "请选择车辆类型",
          dicData: Dic.find("SENU038"),
          viewFormatter: (row, value) => {
            if (value) {
              return Dic.findByValue("SENU038", Number(value));
            }
            return "";
          },
          // rules: [{
          //   required: true,
          //   message: '请输入车辆类型',
          //   trigger: 'blur'
          // }],
          formatter: function (row, value) {
            return value ? Dic.findByValue("SENU038", value) : "";
          }
        },
        {
          label: "访客车辆类型",
          prop: "visitorVehicleTypeName",
          type: "select",
          hide: false,
          search: false,
          addDisplay: true,
          formslot: true,
          editDisplay: false,
          span: 12,
          align: "right"
        },
        // {
        //   label: "录入时间",
        //   prop: "modifyTime",
        //   hide: true,
        //   type: "datetime",
        //   search: false,
        //   span: 24,
        //   formatter: function (row, value) {
        //     return value
        //       ? utils.Dates.dayjs(value).format("YYYY-MM-DD HH:mm:ss")
        //       : "";
        //   }
        // },
        {
          label: "车辆备注说明",
          prop: "desc",
          type: "textarea",
          hide: false,
          search: false,
          addDisplay: true,
          editDisplay: false,
          span: 24,
          align: "right"
        }
      ]
    };
  }
};